import { NextPageContext, GetServerSidePropsContext } from 'next';

/**
 * @param name Name of the cookie
 * @param ctx NextPageContext
 * @param shouldJsonParse Set to true if Cookie contains valid stringified JSON
 */
function getServerCookie(
  name: string,
  ctx?: NextPageContext | GetServerSidePropsContext,
  shouldJsonParse?: boolean,
) {
  const cookie = ctx?.req?.headers?.cookie;
  if (cookie) {
    const cookieName = `${name}=`;
    const decodedCookie = decodeURIComponent(cookie);
    const cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
      let current = cookieArray[i];
      while (current.charAt(0) === ' ') {
        current = current.substring(1);
      }
      if (current.indexOf(cookieName) === 0) {
        const cookieS = current.substring(cookieName.length, current.length);
        if (shouldJsonParse) {
          try {
            return JSON.parse(cookieS);
          } catch (_error) {
            return cookieS;
          }
        }
        return cookieS;
      }
    }
  }
  return undefined;
}

export { getServerCookie };
